






















































import { Component, Vue, Watch } from 'vue-property-decorator'
import * as qs from 'qs'
import { isWeixin } from '@ivy/fts/utils'
import * as utils from '@ivy/fts/utils'
import { requireGet, requirePost } from './require'

@Component
export default class Index extends Vue {
  qrcode: string = ''
  courseInfo: any = {}
  helperInfo: any = {}
  tid: any
  course_start_time: string
  bought: number
  out_trade_no: any
  mes: any
  introCont: any = [
    '毕业于国内双一流大学。',
    '曾任职于知名在线教育公司，多年孩子教育经验，培养上千名学员。',
    '我坚信，做好孩子的教育就是赢得每个家庭的未来。',
  ]
  async created() {
    const {
      order,
      result,
      total_fee,
      tid,
      is_from_market,
      course_start_time,
      bought,
      out_trade_no,
    } = qs.parse(this.$route.query)
    const { source }: any = this.$route.query
    if (source === 'activation') {
      // 微信生态外投放来的新用户
      return await this.getActivationData()
    }
    this.tid = tid
    this.out_trade_no = out_trade_no
    this.course_start_time = course_start_time
    this.bought = +bought
    debugger
    if (isWeixin() && total_fee > 0 && !result.includes('chooseWXPay:ok')) {
      this.$router.go(-1)
    }
    await this.sendOkInfo()
    await this.getData()
    if (is_from_market === '0') return
    if (utils.cacheGet('hasSendTid') === tid) return
    await this.sendPayDoneTempMsg(order)
  }
  async getData() {
    await this.$store.login()
    const r: any = this.$route.query.qr_code_url
    this.qrcode = r ? decodeURIComponent(r) : ''
    if (this.qrcode) return this.getCourseInfo()
    const { data } = await requireGet(
      `/api/m-course/crm/crmUpdateRegister?tid=${this.tid}&need_course_info=1`
    )
    this.helperInfo = data.helper_info || {}
    this.courseInfo = data.course_info || {}
    if (this.helperInfo.message) {
      this.$Toast(this.helperInfo.message)
    }
  }
  async getCourseInfo() {
    const { data } = await requireGet(
      `/api/m-course/crm/getCourseInfoByQrcode?qr_code_url=${this.qrcode}`
    )
    this.helperInfo = data.helper_info || {}
    this.courseInfo = data.course_info || {}
  }
  async getActivationData() {
    const loginInfo = await this.$store.login()
    if (!loginInfo.token) {
      return await this.$store.showBindPhone()
    }
    try {
      const { data } = await requireGet(
        `/api/activity/crm/put/getActivationData`
      )
      if (data.code === 'NOT_FOUND') {
        return this.$Toast(data.message)
      }
      this.helperInfo = data.helper_info || {}
      this.courseInfo = data.course_info || {}
      if (this.helperInfo.message) {
        this.$Toast(this.helperInfo.message)
      }
    } catch (error) {
      console.log(error)
    }
  }
  //发送支付成功消息
  async sendOkInfo() {
    let { data } = await this.$axios.post(
      `/api/goods/order/pay/callback`,
      {
        out_trade_no: this.out_trade_no,
        type: 'wechat',
      },
      {
        disableAlert: true,
      }
    )
    if (data.message) {
      this.$Toast(data.message)
    }
  }
  async sendPayDoneTempMsg(order) {
    const act_id = utils.cacheGet('actId')
    const channel_id = utils.cacheGet('channelId')
    const userInfo = await this.$store.login()
    // 发送公众号模板消息
    await requireGet('/api/activity/crm/put/sendPayDoneTempMsg', {
      tid: this.tid,
      mem_id: userInfo.user.id,
      course_title: this.courseInfo.title,
      nickname: userInfo.user.member_nick,
      course_start_time: this.course_start_time,
    })
    utils.cacheSet('hasSendTid', this.tid)
    this.$Toast('报名成功')
  }
}
